import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugin/vuetify'
import i18n from '@/plugin/i18n'
import { api } from '@/api'
import VueClipboard from 'vue-clipboard2'
import VueToastr from "vue-toastr";
import Loading from 'vue-loading-overlay';
import VueSession from 'vue-session'
import VueGoodTablePlugin from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'
import JsonExcel from 'vue-json-excel';
import AppContentAdmin from '@/components/core/page.slot';

import '@/plugin/index'
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from 'moment'

window.api = api
window.i18n = i18n
window.moment = moment

Vue.use(VueToastr, {
    defaultTimeout: 5000,
    defaultPosition: "toast-top-right",
    defaultClassNames: ["animated", "zoomInUp"]
});

Vue.use(VueClipboard);

Vue.use(Loading);

Vue.use(VueGoodTablePlugin);

Vue.use(VueSession);

Vue.component('downloadExcel', JsonExcel);

Vue.component('app-content-admin', AppContentAdmin);

Vue.config.productionTip = false

Vue.mixin({
    methods: {
        localDate(date) {
            return moment(date + ' Z', 'YYYY-MM-DD HH:mm:ss Z', true).format('YYYY-MM-DD HH:mm:ss');
        },
        truncateDate(date) {
            return moment(date + ' Z', 'YYYY-MM-DD HH:mm:ss Z', true).format('MMM-DD-YYYY');
        },
        truncateDateTime(date) {
            return moment(date + ' Z', 'YYYY-MM-DD HH:mm:ss Z', true).format('YYYY-MM-DD');
        },
        formatH5date(date) {
            return moment(date + ' Z', 'DD-MM-YYYY Z', true).format('YYYY-MM-DD');
        },
        parseFloatToFixed(data, places, replace = true) {
            if (replace) {
                return parseFloat(data).toFixed(places).replace(/\.?0+$/, "");
            }

            return parseFloat(data).toFixed(places);
        },
        truncateToDecimals(num, dec = 2) {
            const calcDec = Math.pow(10, dec);
            return Math.trunc(parseFloat(num) * calcDec) / calcDec;
        },
        trim(value, len = null) {
            if (value.length > len) {
                return `${value.substring(0, len)} ...`
            }
            else {
                return value
            }
        },
        thoudsandSeparator(num, decimal = false) {
            num = this.parseFloatToFixed(+num, 2, !decimal)
            return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        },
        trimEmpty(val) {
            if (val == null || val == "") return '-'
            else return val
        },
        getCookie(name) {
            var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
            return v ? v[2] : null;
        },
        setCookie(name, value, days) {
            var d = new Date;
            d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
            document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
        },
        deleteCookie(name) {
            setCookie(name, '', -1);
        },
        alphanumeric(inputtxt) {
            if (inputtxt.search(/\d/) == -1 || inputtxt.search(/[a-zA-Z]/) == -1) {
                return false;
            }
            else {
                return true;
            }
        },
        $can(binding) {
            return store.getters["permission/permission"].indexOf(binding) !== -1;
        },
    }
});

Vue.directive('can', function (el, binding) {
    return store.getters["permission/permission"].indexOf(binding) !== -1;
})

new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App)
}).$mount('#app')
